<script>
import marked from 'marked'

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      input: this.text,
      preview: false,
      selected: null
    }
  },
  computed: {
    formattedText() {
      if (this.input) {
        return marked(this.input, {
          gfm: true,
          headerIds: false,
          sanitize: true
        }).trim()
      }
    }
  },
  methods: {
    togglePreview() {
      this.preview = !this.preview
      return this.preview
    },
    markSelection(type) {
      if (!this.selected) return this.input
      let text = this.input
      let string = ''
      if (type == 'bold') {
        if (this.selected.string.startsWith('**') && this.selected.string.endsWith('**')) {
          string = this.selected.string.replace(/\*/g, '')
        } else {
          string = '**' + this.selected.string + '**'
          this.format = 'bold'
        }

        text = text.slice(0, this.selected.start) + string + text.slice(this.selected.end)
      }
      if (type == 'italic') {
        if (this.selected.string.startsWith('_') && this.selected.string.endsWith('_')) {
          string = this.selected.string.replace(/\_/g, '')
        } else {
          string = '_' + this.selected.string + '_'
          this.format = 'italic'
        }
        text = text.slice(0, this.selected.start) + string + text.slice(this.selected.end)
      }
      this.selected = null
      return this.input = text
    }
  },
  render() {
    return this.$scopedSlots.default({
      preview: this.preview,
      inputProps: {
        value: this.input
      },
      inputEvents: {
        keyup: e => (this.input = e.target.value),
        select: e => (
          this.selected = {
            start: e.target.selectionStart,
            string: e.target.value.substring(e.target.selectionStart, e.target.selectionEnd),
            end: e.target.selectionEnd,
          }
        ),
        deselect: e => (this.selected = null)
      },
      markedDescription: this.formattedText,
      tabEvents: {
        click: () => this.togglePreview()
      },
      editorEvents: {
        click: e => (this.markSelection(e.target.getAttribute('data-type')))
      }
    })
  }
}
</script>
